var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/constants.ts
var parseRegex = (
  // eslint-disable-next-line prefer-named-capture-group, unicorn/no-unsafe-regex
  /(-?(?:\d+)?\.?\d+) *(m(?:illiseconds?|s(?:ecs?)?))?(s(?:ec(?:onds?|s)?)?)?(h(?:ours?|rs?)?)?(d(?:ays?)?)?(w(?:eeks?|ks?)?)?(mo(?:n(?:ths?|s)?)?)?(m(?:in(?:utes?|s)?)?)?(y(?:ears?|rs?)?)?/gi
);
var dateFormateRegex = /yyyy|yy|MMMM|MMM|MM|dd|HH|hh|mm|ss|SS|Do|DDD|DD|D|Z|A|a|X|x/g;
var Time = /* @__PURE__ */ ((Time2) => {
  Time2[Time2["MilliSecond"] = 1] = "MilliSecond";
  Time2[Time2["Second"] = 1e3] = "Second";
  Time2[Time2["Minute"] = 6e4] = "Minute";
  Time2[Time2["Hour"] = 36e5] = "Hour";
  Time2[Time2["Day"] = 864e5] = "Day";
  Time2[Time2["Week"] = 6048e5] = "Week";
  Time2[Time2["Month"] = 2592e6] = "Month";
  Time2[Time2["Year"] = 31536e6] = "Year";
  return Time2;
})(Time || {});
var timeFormats = [
  "year",
  "y",
  "month",
  "mo",
  "week",
  "w",
  "day",
  "d",
  "hour",
  "h",
  "minute",
  "min",
  "m",
  "second",
  "s",
  "millisecond",
  "milli",
  "ms"
];
var months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

// src/date.ts
var padLeftZero = /* @__PURE__ */ __name((num) => {
  return num.toString().padStart(2, "0");
}, "padLeftZero");
var date = /* @__PURE__ */ __name((input, format2 = "yyyy-MM-dd HH:mm:ss", locale = "en-US") => {
  const dateObj = input instanceof Date ? input : new Date(input);
  const year = dateObj.getFullYear();
  const month = dateObj.getMonth() + 1;
  const day = dateObj.getDate();
  const hour = dateObj.getHours();
  const minute = dateObj.getMinutes();
  const dayOfWeekStr = dateObj.toLocaleDateString(locale, {
    weekday: "long"
  });
  return format2.replace(dateFormateRegex, (match) => {
    switch (match) {
      case "yyyy":
        return year.toString();
      case "yy":
        return year.toString().slice(2);
      case "MMMM":
        return months[month - 1];
      case "MMM":
        return months[month - 1].slice(0, 3);
      case "MM":
        return padLeftZero(month);
      case "dd":
      case "DD":
        return padLeftZero(day);
      case "HH":
      case "hh":
        return padLeftZero(/a/i.test(format2) ? hour % 12 : hour);
      case "mm":
        return padLeftZero(minute);
      case "ss":
        return padLeftZero(dateObj.getSeconds());
      case "SS":
        return padLeftZero(dateObj.getMilliseconds());
      case "Do":
        return `${dayOfWeekStr}`;
      case "DDD":
        return dayOfWeekStr.slice(0, 3);
      case "D":
        return day.toString();
      case "Z":
        return (dateObj.getTimezoneOffset() / 60).toString();
      case "A":
        return dateObj.getHours() < 12 ? "AM" : "PM";
      case "a":
        return dateObj.getHours() < 12 ? "am" : "pm";
      case "X":
        return (dateObj.getTime() / 1e3).toString();
      case "x":
        return dateObj.getTime().toString();
    }
  });
}, "date");

// src/format.ts
var fmt = /* @__PURE__ */ __name((val, pfx, str, long, separator, decimal) => {
  const base = 10 ** decimal;
  const num = Math.round(val * base) / base;
  return `${pfx}${num}` + (long ? separator + str + (Number.parseFloat(`${num}`) === 1 ? "" : "s") : str === "month" ? str.slice(0, 2) : str[0]);
}, "fmt");
var format = /* @__PURE__ */ __name((ms, {
  long = false,
  separator = " ",
  decimal = 0
} = {}) => {
  if (!ms || typeof ms !== "number")
    return;
  const pfx = ms < 0 ? "-" : "";
  const abs = Math.abs(ms);
  if (abs < 1e3 /* Second */)
    return `${ms}` + (long ? `${separator}millisecond${ms === 1 ? "" : "s"}` : "ms");
  if (abs < 6e4 /* Minute */)
    return fmt(abs / 1e3 /* Second */, pfx, "second", long, separator, decimal);
  if (abs < 36e5 /* Hour */)
    return fmt(abs / 6e4 /* Minute */, pfx, "minute", long, separator, decimal);
  if (abs < 864e5 /* Day */)
    return fmt(abs / 36e5 /* Hour */, pfx, "hour", long, separator, decimal);
  if (abs < 2592e6 /* Month */)
    return fmt(abs / 864e5 /* Day */, pfx, "day", long, separator, decimal);
  if (abs < 31536e6 /* Year */)
    return fmt(abs / 2592e6 /* Month */, pfx, "month", long, separator, decimal);
  return fmt(abs / 31536e6 /* Year */, pfx, "year", long, separator, decimal);
}, "format");

// src/parse.ts
var parse = /* @__PURE__ */ __name((input) => {
  if (!input || typeof input !== "string")
    return;
  let result = 0;
  const matches = [...input.matchAll(parseRegex)];
  if (!matches.length)
    return;
  for (const match of matches) {
    let num = Number.parseFloat(match[1]);
    if (match[3])
      num *= 1e3 /* Second */;
    if (match[4])
      num *= 36e5 /* Hour */;
    if (match[5])
      num *= 864e5 /* Day */;
    if (match[6])
      num *= 6048e5 /* Week */;
    if (match[7])
      num *= 2592e6 /* Month */;
    if (match[8])
      num *= 6e4 /* Minute */;
    if (match[9])
      num *= 31536e6 /* Year */;
    result += num;
  }
  return result;
}, "parse");

// src/prettyFormat.ts
var prettyFormat = /* @__PURE__ */ __name((ms, { patterns = timeFormats, format: format2 = "long", separator = ", " } = {}) => {
  if (!ms || typeof ms !== "number")
    return;
  const sign = ms < 0 ? "-" : "";
  let abs = Math.abs(ms);
  const results = patterns.reduce((acc, pattern) => {
    const result = getValue(pattern, abs);
    if (result.value) {
      acc.push(
        `${result.value}${format2 === "short" ? result.unit === "month" ? "mo" : result.unit === "millisecond" ? "ms" : result.unit[0] : result.value === 1 ? ` ${result.unit}` : ` ${result.unit}s`}`
      );
      abs -= result.value * result.ms;
    }
    return acc;
  }, []);
  if (results.length === 0)
    return;
  return `${sign}${results.join(separator)}`;
}, "prettyFormat");
function getValue(pattern, abs) {
  switch (pattern) {
    case "year":
    case "y":
      return {
        value: abs >= 31536e6 /* Year */ ? Math.floor(abs / 31536e6 /* Year */) : void 0,
        ms: 31536e6 /* Year */,
        unit: "year"
      };
    case "month":
    case "mo":
      return {
        value: abs >= 2592e6 /* Month */ ? Math.floor(abs / 2592e6 /* Month */) : void 0,
        ms: 2592e6 /* Month */,
        unit: "month"
      };
    case "week":
    case "w":
      return {
        value: abs >= 6048e5 /* Week */ ? Math.floor(abs / 6048e5 /* Week */) : void 0,
        ms: 6048e5 /* Week */,
        unit: "week"
      };
    case "day":
    case "d":
      return {
        value: abs >= 864e5 /* Day */ ? Math.floor(abs / 864e5 /* Day */) : void 0,
        ms: 864e5 /* Day */,
        unit: "day"
      };
    case "hour":
    case "h":
      return {
        value: abs >= 36e5 /* Hour */ ? Math.floor(abs / 36e5 /* Hour */) : void 0,
        ms: 36e5 /* Hour */,
        unit: "hour"
      };
    case "minute":
    case "min":
    case "m":
      return {
        value: abs >= 6e4 /* Minute */ ? Math.floor(abs / 6e4 /* Minute */) : void 0,
        ms: 6e4 /* Minute */,
        unit: "minute"
      };
    case "second":
    case "s":
      return {
        value: abs >= 1e3 /* Second */ ? Math.floor(abs / 1e3 /* Second */) : void 0,
        ms: 1e3 /* Second */,
        unit: "second"
      };
    case "millisecond":
    case "milli":
    case "ms":
      return {
        value: abs >= 1 ? Math.floor(abs) : void 0,
        ms: 1,
        unit: "millisecond"
      };
    default:
      return {
        value: void 0,
        ms: 0,
        unit: ""
      };
  }
}
__name(getValue, "getValue");
var Formatter = class {
  constructor({ patterns = timeFormats, format: format2 = "long", separator = ", " } = {}) {
    __publicField(this, "patterns");
    __publicField(this, "unitFormat");
    __publicField(this, "separator");
    this.patterns = patterns;
    this.unitFormat = format2;
    this.separator = separator;
  }
  setFormat(format2) {
    this.unitFormat = format2;
    return this;
  }
  setSeparator(separator) {
    this.separator = separator;
    return this;
  }
  setPatterns(patterns) {
    this.patterns = patterns;
    return this;
  }
  format(ms) {
    return prettyFormat(ms, {
      patterns: this.patterns,
      format: this.unitFormat,
      separator: this.separator
    });
  }
};
__name(Formatter, "Formatter");

// src/relativeTime.ts
var relativeTime = /* @__PURE__ */ __name((time, from = /* @__PURE__ */ new Date()) => {
  const givenDate = time instanceof Date ? time : new Date(time);
  const dateFrom = from instanceof Date ? from : new Date(from);
  let diff = dateFrom.getTime() - givenDate.getTime();
  if (diff > 0) {
    if (diff < 1e3 /* Second */ * 2) {
      return "just now";
    }
    if (diff < 6e4 /* Minute */) {
      return `${Math.floor(diff / 1e3 /* Second */)} seconds ago`;
    }
    if (diff < 6e4 /* Minute */ * 2) {
      return "a minute ago";
    }
    if (diff < 36e5 /* Hour */) {
      return `${Math.floor(diff / 6e4 /* Minute */)} minutes ago`;
    }
    if (diff < 36e5 /* Hour */ * 2) {
      return "an hour ago";
    }
    if (diff < 864e5 /* Day */) {
      return `${Math.floor(diff / 36e5 /* Hour */)} hours ago`;
    }
    if (diff < 864e5 /* Day */ * 2) {
      return "yesterday";
    }
    if (diff < 6048e5 /* Week */) {
      return `${Math.floor(diff / 864e5 /* Day */)} days ago`;
    }
    if (diff < 864e5 /* Day */ * 14) {
      return "a week ago";
    }
    if (diff < 864e5 /* Day */ * 31) {
      return `${Math.floor(diff / 6048e5 /* Week */)} weeks ago`;
    }
    if (diff < 864e5 /* Day */ * 61) {
      return "a month ago";
    }
    if (diff < 31536e6 /* Year */) {
      return `${Math.floor(diff / 2592e6 /* Month */)} months ago`;
    }
    if (diff < 31536e6 /* Year */ * 2) {
      return "a year ago";
    }
    return `${Math.floor(diff / 31536e6 /* Year */)} years ago`;
  }
  diff = -diff;
  if (diff < 1e3 /* Second */ * 2) {
    return "in a few seconds";
  }
  if (diff < 6e4 /* Minute */) {
    return `in ${Math.floor(diff / 1e3 /* Second */)} seconds`;
  }
  if (diff < 6e4 /* Minute */ * 2) {
    return "in a minute";
  }
  if (diff < 36e5 /* Hour */) {
    return `in ${Math.floor(diff / 6e4 /* Minute */)} minutes`;
  }
  if (diff < 36e5 /* Hour */ * 2) {
    return "in an hour";
  }
  if (diff < 864e5 /* Day */) {
    return `in ${Math.floor(diff / 36e5 /* Hour */)} hours`;
  }
  if (diff < 864e5 /* Day */ * 2) {
    return "tomorrow";
  }
  if (diff < 6048e5 /* Week */) {
    return `in ${Math.floor(diff / 864e5 /* Day */)} days`;
  }
  if (diff < 864e5 /* Day */ * 14) {
    return "in a week";
  }
  if (diff < 864e5 /* Day */ * 31) {
    return `in ${Math.floor(diff / 6048e5 /* Week */)} weeks`;
  }
  if (diff < 864e5 /* Day */ * 61) {
    return "in a month";
  }
  if (diff < 31536e6 /* Year */) {
    return `in ${Math.floor(diff / 2592e6 /* Month */)} months`;
  }
  if (diff < 31536e6 /* Year */ * 2) {
    return "in a year";
  }
  return `in ${Math.floor(diff / 31536e6 /* Year */)} years`;
}, "relativeTime");
export {
  Formatter,
  Time,
  date,
  dateFormateRegex,
  format,
  months,
  parse,
  parseRegex,
  prettyFormat,
  relativeTime,
  timeFormats
};
//# sourceMappingURL=index.mjs.map